import type { MemberDto, PaginatedResponse } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type Args = {
	group?: string;
	page?: number;
	perPage?: number;
};

export function useGetMembers(args: Args = {}) {
	return useQuery({
		queryKey: ["members", args.group, args.page, args.perPage],
		queryFn: async () => {
			const res = await fetch(constructUrl(args), {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch members");
			}

			return (await res.json()) as PaginatedResponse<MemberDto>;
		},
	});
}

function constructUrl({ group, page, perPage }: Args) {
	const url = new URL("/api/members", SERVICE_API);
	if (group && group !== "all") {
		url.searchParams.append("group", group);
	}

	if (page !== undefined) {
		url.searchParams.append("page", String(page));
	}

	if (perPage !== undefined) {
		url.searchParams.append("perPage", String(perPage));
	}

	return url.toString();
}
